var map = {
	"./bx_account.svg": 48159,
	"./bx_account_active.svg": 43976,
	"./bx_earn.svg": 23124,
	"./bx_earn_active.svg": 29729,
	"./bx_history.svg": 43190,
	"./bx_history_active.svg": 18523,
	"./bx_home.svg": 46159,
	"./bx_home_active.svg": 56152,
	"./bx_notifications.svg": 42970,
	"./bx_notifications_active.svg": 59063,
	"./bx_savings.svg": 28259,
	"./bx_savings_active.svg": 31940,
	"./bx_withdraw.svg": 3424,
	"./bx_withdraw_active.svg": 40021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69151;